import React from 'react';

export const LayoutDebugVisualizerContext = React.createContext<
  {showDebugBorders: 'show' | 'hide'} | undefined
>(undefined);
